import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { studyLabManagementFileServices } from "../../../../APIServices/studyLabManagementFileServices";
import { useParams } from "react-router";
import { handleResponse } from "../../../../APIHelpers/Responses";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const UploadStudyLabFile = ({
  Show,
  Hide,
  Title,
  getStudyLabManagementData,
}) => {
  const { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [formId, setFormId] = useState("");
  const [mainVersion, setMainVersion] = useState("");
  const [formVersion, setFormVersion] = useState("");
  const [datasetType, setDatasetType] = useState("");
  const [formList, setFormList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [buttonLoader, setButtonLoader] = useState(false);

  const uploadStudyLabManagementFile = async () => {
    setButtonLoader(true);
    const formData = new FormData();
    formData.append("studyId", studyId);
    formData.append("fileName", fileName);
    formData.append("formId", formId);
    formData.append("formVersion", formVersion);
    formData.append("datasetType", datasetType);
    formData.append("mode", StudyMode);
    formData.append("file", file);
    const data =
      await studyLabManagementFileServices.uploadStudyLabManagementFile(
        formData
      );
    if (data?.statusCode === 200) {
      setFileName("");
      setFormId("");
      setFormVersion("");
      setDatasetType("");
      setFile(null);
      getStudyLabManagementData();
      Hide();
    }
    setButtonLoader(false);
  };

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  useEffect(() => {
    if (Show) {
      setFileName("");
      setFormId("");
      setFormVersion("");
      setDatasetType("");
      setSelectedFile(null);
    }
  }, [Show]);

  useEffect(() => {
    getStudyLevelForm()
  }, []);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              Upload File{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>

            <Form.Control
              type="file"
              className="br3"
              accept=".csv,.xls,.xlsx"
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) {
                  setFile(null);
                  return;
                }

                const allowedExtensions = [".csv", ".xls", ".xlsx"];
                const extension = file.name
                  .substring(file.name.lastIndexOf("."))
                  .toLowerCase();

                if (!allowedExtensions.includes(extension)) {
                  handleResponse({
                    statusCode: 400,
                    customMessage: "Only CSV and Excel files are allowed."
                  });
                  e.target.value = "";
                  setFile(null);
                  return;
                }

                setFile(file);
              }}
            />

            {file && (
              <small className="text-muted d-block mt-1">
                {file.name}
              </small>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              File Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
              placeholder="Enter File Name"
              className="br3"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              value={formId}
              onChange={(e) => { setFormId(e.target.value); setMainVersion(e.target[e.target.selectedIndex].title) }}
              style={{ fontSize: 12 }}
              className="br3"
            >
              <option value="">Select Form</option>
              {formList?.map((item, index) => (
                <option key={index} value={item?.formId} title={item?.version}>{item?.formName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Dataset Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setDatasetType(e.target.value)}
              className="br3"
              value={datasetType}
              style={{ fontSize: 12 }}
            >
              <option value="">Select Dataset Type</option>
              <option value="row">Row Dataset</option>
              <option value="column">Column Dataset</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Version{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setFormVersion(e.target.value)}
              className="br3"
              value={formVersion}
              disabled={!mainVersion}
              style={{ fontSize: 12 }}
            >
              <option value="">Select Version</option>
              {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
                <option key={index} value={versionNumber}>Version {versionNumber}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>

        <div className="p-2 bg-light border-top hstack justify-content-end gap-2">
          <button
            className="updateProfile"
            disabled={!fileName || !formId || !formVersion || !datasetType || !file || buttonLoader}
            onClick={uploadStudyLabManagementFile}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner animation="border" size="sm" />
                Uploading...
              </div>
            ) : (
              "Upload File"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UploadStudyLabFile;